import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import i18n, {
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  getStoredLocale,
  htmlLangForLocale
} from '../i18n'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref(getStoredLocale())

  const currentLocale = computed(() => locale.value)

  const syncDocumentMeta = () => {
    try {
      document.documentElement.lang = htmlLangForLocale(locale.value)
      document.title = i18n.global.t('app.documentTitle')
    } catch {
      /* ignore SSR / tests */
    }
  }

  const applyLocale = (code) => {
    locale.value = code
    i18n.global.locale.value = code
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, code)
      syncDocumentMeta()
    } catch (error) {
      console.error('Erro ao aplicar locale:', error)
    }
  }

  const setLocale = (code) => {
    if (!SUPPORTED_LOCALES.includes(code)) {
      applyLocale(DEFAULT_LOCALE)
      return
    }
    applyLocale(code)
  }

  applyLocale(locale.value)

  watch(
    () => i18n.global.locale.value,
    () => syncDocumentMeta()
  )

  return {
    locale: currentLocale,
    supportedLocales: SUPPORTED_LOCALES,
    setLocale
  }
})
